const BulletPoint = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width='8'
      height='9'
      viewBox='0 0 8 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='8'
        height='9'
        fill='transparent'
      />
      <g>
        <path
          d='M-4069 -3581C-4069 -3582.1 -4068.1 -3583 -4067 -3583H10445C10446.1 -3583 10447 -3582.1 10447 -3581V4919C10447 4920.1 10446.1 4921 10445 4921H-4067C-4068.1 4921 -4069 4920.1 -4069 4919V-3581Z'
          fill='transparent'
        />
        <path
          d='M-4067 -3582H10445V-3584H-4067V-3582ZM10446 -3581V4919H10448V-3581H10446ZM10445 4920H-4067V4922H10445V4920ZM-4068 4919V-3581H-4070V4919H-4068ZM-4067 4920C-4067.55 4920 -4068 4919.55 -4068 4919H-4070C-4070 4920.66 -4068.66 4922 -4067 4922V4920ZM10446 4919C10446 4919.55 10445.6 4920 10445 4920V4922C10446.7 4922 10448 4920.66 10448 4919H10446ZM10445 -3582C10445.6 -3582 10446 -3581.55 10446 -3581H10448C10448 -3582.66 10446.7 -3584 10445 -3584V-3582ZM-4067 -3584C-4068.66 -3584 -4070 -3582.66 -4070 -3581H-4068C-4068 -3581.55 -4067.55 -3582 -4067 -3582V-3584Z'
          fill='white'
          fill-opacity='0.1'
        />
        <g id='Hero-ricetta'>
          <rect
            width='375'
            height='1515'
            transform='translate(-16 -646)'
            fill='transparent'
          />
          <g id='text container'>
            <g id='Li'>
              <g id='a'>
                <circle
                  id='Ellipse 1'
                  cx='4'
                  cy='4.5'
                  r='4'
                  // fill='#E67D05'
                  fill='currentColor'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default BulletPoint
